    @if (visible) {
      <!-- Phones get one row, not a stack: stacked, this banner was 129px — a
           fifth of a small phone screen — and it sat over the primary action on
           the pages below it (the Log in button, at some scroll positions). One
           row lands at ~72px. The full sentence and the policy link return at md,
           where there is room for them. Buttons keep their 44px targets. -->
      <aside #banner role="region" aria-label="Cookie consent"
        class="fixed left-0 right-0 z-[60] bg-white border-t border-dark-text/10 shadow-[0_-8px_24px_rgba(0,0,0,0.06)] px-4 md:px-8 pt-2.5 md:pt-4 short:pt-2 pb-[calc(0.625rem+env(safe-area-inset-bottom))] md:pb-[calc(1rem+env(safe-area-inset-bottom))] short:pb-[calc(0.5rem+env(safe-area-inset-bottom))]"
        [style.bottom.px]="bottomOffset">
        <div class="max-w-[80rem] mx-auto flex flex-row items-center gap-3 md:gap-6">
          <div class="flex items-center md:items-start gap-2 md:gap-3 flex-1 min-w-0">
            <span class="material-symbols-outlined text-trinidad shrink-0 md:mt-0.5" style="font-variation-settings: 'FILL' 1;" aria-hidden="true">cookie</span>
            <p class="text-xs md:text-sm short:text-xs font-body text-dark-text leading-snug md:leading-relaxed short:leading-snug">
              We use cookies to make the site work<span class="hidden md:inline short:hidden"> and remember your preferences</span>.
              <a routerLink="/cookies" class="hidden md:inline short:hidden text-trinidad font-bold hover:underline">Read the policy</a><span class="hidden md:inline short:hidden">.</span>
            </p>
          </div>
          <div class="flex items-center gap-2 shrink-0">
            <button type="button" (click)="decline()"
              class="min-h-[44px] px-3 md:px-4 py-2.5 rounded-full bg-white border border-dark-text/15 text-dark-text text-[0.65rem] md:text-xs uppercase tracking-[0.12em] font-button font-bold hover:border-dark-text transition-colors">
              Decline
            </button>
            <button type="button" (click)="accept()"
              class="min-h-[44px] px-4 md:px-6 py-2.5 rounded-full bg-trinidad text-white text-[0.65rem] md:text-xs uppercase tracking-[0.12em] font-button font-bold hover:opacity-90 transition-opacity">
              Accept
            </button>
          </div>
        </div>
      </aside>
    }
